module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/e2acf5736e1d90846a624393f8656c69.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Platinum/Platinum0.svg
// module id = 77wF
// module chunks = 1